<common-ui-components-page-layout
  [stickyHeader]="true"
  [showBackIcon]="false"
  [bodyClasses]="'surface-back'"
>
  <div class="mb-medium">
    <transactions-applet-card-actions></transactions-applet-card-actions>
  </div>

  <div class="px-big mb-medium">
    <payment-transactions-upcoming-transactions-summary></payment-transactions-upcoming-transactions-summary>
  </div>
  <div class="px-big mb-medium">
    <transactions-applet-pending-transactions-summary></transactions-applet-pending-transactions-summary>
  </div>
  <div class="px-big mb-medium">
    <transactions-applet-past-transactions-summary></transactions-applet-past-transactions-summary>
  </div>
  <div class="px-big mb-medium">
    <transactions-applet-frequent-transactions-summary></transactions-applet-frequent-transactions-summary>
  </div>
</common-ui-components-page-layout>
